/** Unified movement input: keyboard (by physical key code) and the on-screen d-pad. */
const held = new Set<string>();
const pad = { up: false, down: false, left: false, right: false };

const UP = ['ArrowUp', 'KeyW'];
const DOWN = ['ArrowDown', 'KeyS'];
const LEFT = ['ArrowLeft', 'KeyA'];
const RIGHT = ['ArrowRight', 'KeyD'];
export const MOVE_CODES = new Set([...UP, ...DOWN, ...LEFT, ...RIGHT]);

export const input = {
  keyDown(code: string): void {
    held.add(code);
  },
  keyUp(code: string): void {
    held.delete(code);
  },
  setPad(dir: keyof typeof pad, on: boolean): void {
    pad[dir] = on;
  },
  /** Drop everything (window blur, a UI layer opening...). */
  reset(): void {
    held.clear();
    pad.up = pad.down = pad.left = pad.right = false;
  },
  /** Normalised direction vector. */
  axis(): { x: number; y: number } {
    const any = (codes: string[]) => codes.some((c) => held.has(c));
    let x = 0, y = 0;
    if (any(UP) || pad.up) y -= 1;
    if (any(DOWN) || pad.down) y += 1;
    if (any(LEFT) || pad.left) x -= 1;
    if (any(RIGHT) || pad.right) x += 1;
    const len = Math.hypot(x, y);
    return len ? { x: x / len, y: y / len } : { x: 0, y: 0 };
  },
};
